const lang = {
  AllStock: {
    symbol: '代號',
    strategy: '策略',
    longShort: '多空',
    long: '多',
    short: '空',
    linearTrend: '線性走勢',
    pleaseEnterNumberOrName: '請輸入股票代碼或名稱',
    desc: '台股資料來源為台灣證券交易所，使用者依本資料交易發生損失，需自行負責。本服務對資料內容錯誤，更新延誤或傳輸中斷不負任何責任，您應對所為之任何金融或投資決策自行負責。本服務旨在進行提供投資回測，過去績效不代表未來績效。',
  },
  Header: {
    login: '登入',
    tryOn: '試用',
    logout: '登出',
  },
  Pricing: {
    plan: '價格方案',
    free: {
      title: '免費',
      fee: 'US$ 0 /月',
      desc: '查看 <strong>一個月前</strong> 市場行情',
      desc2: '查看 <strong>一個月前</strong> 交易部位及績效',
      desc3: '',
      select: '立即查看',
    },
    member: {
      title: '會員',
      fee: 'US$29.99 /月',
      desc: '查看市場 <strong>當日</strong> 行情',
      desc2: '查看 <strong>當日</strong> 交易部位及績效',
      desc3: '收盤前獲取交易建議，<strong>即時</strong>跟單',
      select: '立 即 加 入 會 員\n( 免費試用7天)',
    },
  },
  SocialLogin: {
    title: '社群登入',
    signUpWithFacebook: 'Sign Up with Facebook',
    signUpWithGoogle: 'Sign Up with Google',
  },
  Stock: {
    openingPrice: 'Opening Price',
    closingPrice: 'Closing Price',
    highestPrice: 'Highest Price',
    lowestPrice: 'Lowest Price',
    position: 'Position',
    income: 'Income',
    lot: 'lot',
    point: 'point',
  },
  StockFooter: {
    follow: '加入追蹤',
    watchAll: '觀看全區段',
    desc: '加入會員可查看最近一個月部位，',
    desc2: '並可獲得每日部位簡訊通知',
  },
  Strategy: {
    symbol: '代碼',
    strategy: '策略',
    name: '股票名稱',
    price: '股價',
  },
};

export default lang;
